var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.65857 19.2368C5.65857 20.3947 6.60593 21.3421 7.76383 21.3421C8.92172 21.3421 9.86909 20.3947 9.86909 19.2368M5.65857 19.2368C5.65857 18.0789 6.60593 17.1316 7.76383 17.1316C8.92172 17.1316 9.86909 18.0789 9.86909 19.2368M5.65857 19.2368H2.50067M9.86909 19.2368H10.9217M10.9217 19.2368H16.1849M10.9217 19.2368V7.86842C10.9217 6.68947 10.9217 6.1 11.1533 5.64737C11.3533 5.25789 11.6691 4.93158 12.0691 4.73158C12.5217 4.5 13.1112 4.5 14.2901 4.5H19.1323C20.3112 4.5 20.9007 4.5 21.3533 4.73158C21.7428 4.93158 22.0691 5.24737 22.2691 5.64737C22.5007 6.1 22.5007 6.68947 22.5007 7.86842M10.9217 19.2368V8.71053H6.7112L3.5533 12.9211M16.1849 19.2368C16.1849 20.3947 17.1323 21.3421 18.2901 21.3421C19.448 21.3421 20.3954 20.3947 20.3954 19.2368M16.1849 19.2368C16.1849 18.0789 17.1323 17.1316 18.2901 17.1316C19.448 17.1316 20.3954 18.0789 20.3954 19.2368M20.3954 19.2368C21.5533 19.2368 22.5007 18.2895 22.5007 17.1316V14.5M3.5533 12.9211V19.2368M3.5533 12.9211H10.9217",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5007 11.5H20.5007",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5007 11.5L17.5007 14.5",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5007 11.5L17.5007 8.5",
  stroke: "#61605D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/DeliveryIcon.76d87875.svg";
export { ForwardRef as ReactComponent };